import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles } from 'lucide-react';
export function PreCTA() {
  return <section className="bg-brand-white py-16 md:py-20 px-5 sm:px-6" data-id="element-465">
      <div className="max-w-3xl mx-auto text-center" data-id="element-466">
        <FadeIn data-id="element-467">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-widest text-brand-gold mb-5 flex items-center justify-center gap-2" data-id="element-468">
            <Sparkles className="w-4 h-4" data-id="element-469" />
            Comienza hoy
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-brand-green mb-6 leading-[1.15] tracking-tight" data-id="element-470">
            Hoy puedes comenzar incluso sin experiencia
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-brand-text/75 leading-relaxed mb-7 max-w-2xl mx-auto" data-id="element-471">
            Aprenderás paso a paso cómo usar{' '}
            <span className="font-semibold text-brand-green" data-id="element-472">
              Amazon Seller Central
            </span>
            , publicar productos reales y entender cómo funciona{' '}
            <span className="font-semibold text-brand-green" data-id="element-473">
              Amazon FBA y FBM
            </span>{' '}
            desde cero.
          </p>
          <div className="inline-flex items-center gap-2 bg-brand-beige/60 border border-brand-gold/30 rounded-full px-5 py-2.5" data-id="element-474">
            <span className="text-sm font-bold text-brand-green tracking-wide" data-id="element-475">
              ⚡ ACCESO INMEDIATO + BONOS INCLUIDOS
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}